import React from "react";
import { useQuery } from "@apollo/react-hooks";

import { GET_AUTH_TOKEN } from "graphql/query/user-gql";

import { Authorization } from '../pages';
import { useJwtAuthorization } from "../use-hooks";
import { Loader } from "../result";
import { AppContentProvider } from "components/app-content";


const Authentication = ({ children }) => {

    const { data } = useQuery(GET_AUTH_TOKEN),
          { loading } = useJwtAuthorization();

    const authToken  = (data !== undefined &&
                        data.authToken !== undefined &&
                        data.authToken !== false) ? data.authToken : false;

    if(loading){
        return <Loader type="block" />;
    }

    return (
        <>
            { authToken ?
                <AppContentProvider key={authToken} authToken={authToken}>{children}</AppContentProvider> :
                <Authorization />
            }
        </>
    );
};


export default Authentication;
